import { motion } from 'motion/react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { VideoStill } from './VideoStill';
import { CDN } from '../lib/cdn';

const ease = [0.16, 1, 0.3, 1] as const;

const AUDIENCES = [
  { title: 'Filmmakers', video: CDN.audiences.filmmakers, to: '/for-filmmakers' },
  { title: 'Enterprise', video: CDN.audiences.agencies, to: '/for-enterprise' },
  { title: 'Agencies', video: CDN.audiences.creators, to: '/for-agencies' },
];

const gridVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.14 } },
};
const cardVariants = {
  hidden: { opacity: 0, y: 48 },
  visible: { opacity: 1, y: 0, transition: { duration: 1.1, ease } },
};

function AudCard({ title, video, index, to }: { title: string; video: string; index: number; to: string }) {
  const [hovered, setHovered] = useState(false);

  return (
    <Link to={to} className="block">
      <motion.div
        className={`aud-card relative overflow-hidden cursor-pointer${hovered ? ' is-hovered' : ''}`}
        variants={cardVariants}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div className="relative [aspect-ratio:3/4] overflow-hidden bg-[#080808] max-lg:[aspect-ratio:4/5]">
          <VideoStill
            src={video}
            className="aud-video absolute inset-0 h-full w-full object-cover transition-transform duration-[800ms] [transition-timing-function:cubic-bezier(0.16,1,0.3,1)]"
            aria-label={`Induce for ${title} — product demo`}
          />
          <div className="absolute inset-0 bg-[linear-gradient(to_top,rgba(0,0,0,0.82)_0%,rgba(0,0,0,0.3)_45%,rgba(0,0,0,0.08)_100%)] pointer-events-none" />
          <div className="absolute inset-0 flex flex-col justify-between p-5 pb-7 pointer-events-none">
            <span className="font-mono text-[11px] tracking-[0.18em] text-[rgba(255,255,255,0.45)]">
              {String(index + 1).padStart(2, '0')}
            </span>
            <div className="flex flex-col gap-[10px]">
              <h3 className="font-display font-normal text-[clamp(22px,2.2vw,32px)] tracking-[-0.02em] m-0 text-white leading-[1.1]">
                {title}
              </h3>
              <span className="aud-cta font-mono text-[11px] tracking-[0.14em] text-primary">
                Explore →
              </span>
            </div>
          </div>
        </div>
      </motion.div>
    </Link>
  );
}

export function Audiences() {
  return (
    <section className="section band-dark" id="solutions">
      <div className="container">
        <motion.div
          className="mb-14"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 1, ease }}
        >
          <h2 className="home-section-title m-0 max-w-[14ch]">
            Built for the whole production.
          </h2>
        </motion.div>

        <motion.div
          className="aud-grid grid grid-cols-3 gap-[2px]"
          variants={gridVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-60px' }}
        >
          {AUDIENCES.map((a, i) => (
            <AudCard key={a.title} index={i} title={a.title} video={a.video} to={a.to} />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
